import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useEditProfileMappings = () => {
  const [loading, setLoading] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const editProfileMappings = ({ profileGuid, mappingGuid }, callback) => {
    setLoading(true);

    axiosClient
      .put(`SettingProduct/CoddingProfile/CoddingMappingUpdate`, {
        profileGuid,
        mappingGuid,
      })
      .then(res => {
        if (res.status === 200) {
          enqueueSnackbar(`ویرایش با موفقیت انجام شد`, { variant: 'success' });
          callback();
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => setLoading(false));
  };

  return [editProfileMappings, loading];
};

export default useEditProfileMappings;
